/** @file maskDownload: fetches a slot's mask (silhouette or skeleton) as a signed URL and downloads it. */
import type { ArtDeps } from './artTypes';
import { saveDownload } from './saveDownload';

/** `slotMask(puppetId, key, style)` then a download named `<key with / as _>-<style>.png`. */
export async function maskDownload(deps: Pick<ArtDeps, 'slotMask'>, puppetId: string, key: string, style: 'silhouette' | 'skeleton'): Promise<void> {
  const reply = await deps.slotMask(puppetId, key, style);
  saveDownload(`${key.replaceAll('/', '_')}-${style}.png`, { url: reply.url });
}
